import { 
  getAuth, 
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged 
} from 'firebase/auth';
import { doc, setDoc, getDoc, getFirestore } from 'firebase/firestore';
import { db, auth } from './firebase';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';
console.log('API URL:', API_URL);

export const registerUser = async (email, password, shopName = '', connectShopify = false) => {
  try {
    console.log('Début de l\'inscription avec:', email);
    if (shopName) {
      console.log('Nom de la boutique Shopify:', shopName);
    }
    
    // Vérifier et formater le nom de la boutique Shopify
    let formattedShopName = shopName;
    if (shopName && typeof shopName === 'object') {
      formattedShopName = shopName.domain || '';
      console.log('Formatage du nom de boutique Shopify d\'un objet vers une chaîne:', formattedShopName);
    }
    
    // Supprimer les préfixes http:// ou https:// et les slashes à la fin
    formattedShopName = formattedShopName.replace(/^https?:\/\//, '').replace(/\/$/, '');
    
    // Ajouter .myshopify.com si nécessaire
    if (!formattedShopName.includes('.myshopify.com')) {
      formattedShopName = `${formattedShopName}.myshopify.com`;
    }
    
    // Créer l'utilisateur dans Firebase
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    console.log('Utilisateur créé dans Firebase:', user.uid);

    // Appeler notre API backend
    const url = `${API_URL}/api/auth/register`;
    console.log('Appel API register:', url);
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Origin': window.location.origin
      },
      credentials: 'include',
      body: JSON.stringify({ 
        email: user.email,
        uid: user.uid,
        shopName: formattedShopName || null
      })
    });

    console.log('Status réponse register:', response.status);
    const responseText = await response.text();
    console.log('Réponse texte:', responseText);

    if (!response.ok) {
      let errorMessage;
      try {
        const errorData = JSON.parse(responseText);
        errorMessage = errorData.error;
      } catch (e) {
        errorMessage = responseText;
      }
      throw new Error(errorMessage || 'Erreur lors de l\'inscription');
    }

    // Extraire les données de la réponse
    const data = JSON.parse(responseText);
    console.log('Données utilisateur du backend:', data);
    
    // Stocker le token dans localStorage pour les appels API ultérieurs
    if (data.token) {
      localStorage.setItem('token', data.token);
      console.log('Token stocké dans localStorage après inscription');
    } else {
      console.warn('Aucun token reçu du serveur lors de l\'inscription');
    }

    try {
      console.log('Tentative de création du document utilisateur dans Firestore...');
      console.log('Utilisateur Firebase:', JSON.stringify({
        uid: user.uid,
        email: user.email
      }));
      
      // Créer le document utilisateur dans Firestore
      const userData = {
        email: user.email,
        createdAt: new Date().toISOString(),
        role: 'user',
        isActive: true
      };
      
      // Ajouter les informations Shopify si présentes
      if (formattedShopName) {
        userData.shopifyShop = formattedShopName;
        userData.shopifyConnected = false;
        console.log('Ajout des informations Shopify:', userData.shopifyShop);
      }
      
      console.log('Document utilisateur à créer:', JSON.stringify(userData));
      
      // Vérifier que l'utilisateur est bien authentifié avant d'écrire dans Firestore
      const idToken = await user.getIdToken(true);
      console.log('Token d\'authentification obtenu, longueur:', idToken.length);
      
      try {
        console.log('Attente de 1.5 secondes pour la propagation de l\'authentification...');
        await new Promise(resolve => setTimeout(resolve, 1500));
        
        // Créer le document utilisateur avec gestion d'erreur explicite
        await setDoc(doc(db, 'users', user.uid), userData, { merge: true });
        console.log('✅ Document utilisateur créé avec succès dans Firestore');
      } catch (firestoreError) {
        console.error('❌ Erreur Firestore détaillée:', {
          code: firestoreError.code,
          message: firestoreError.message,
          name: firestoreError.name,
          stack: firestoreError.stack
        });
        
        // Tentative de récupération avec des informations supplémentaires
        if (firestoreError.code === 'permission-denied') {
          console.error('🔒 Permission refusée. Vérifiez :');
          console.error('1. Les règles Firestore');
          console.error('2. L\'authentification Firebase');
          console.error('3. Les droits de l\'utilisateur');
        }
        
        throw firestoreError;
      }
    } catch (error) {
      console.error('❌ Erreur globale lors de la création du document:', {
        code: error.code,
        message: error.message,
        name: error.name,
        stack: error.stack
      });
      throw error;
    }

    // Si l'utilisateur souhaite connecter sa boutique Shopify
    if (connectShopify && formattedShopName) {
      try {
        // Initialiser la connexion Shopify
        const shopifyResponse = await initShopifyConnection(user, formattedShopName, data.token);
        return { ...user, ...data.user, shopifyUrl: shopifyResponse.url };
      } catch (shopifyError) {
        console.error('Erreur lors de l\'initialisation Shopify:', shopifyError);
        // On continue même si l'initialisation Shopify échoue
        // L'utilisateur pourra réessayer plus tard
      }
    }

    return { ...user, ...data.user };
  } catch (error) {
    console.error('Erreur d\'inscription:', error);
    throw error;
  }
};

// Fonction pour initialiser la connexion Shopify
export const initShopifyConnection = async (user, shopName, token = null) => {
  try {
    // Formater le nom de la boutique
    let formattedShop = shopName;
    
    // Supprimer les préfixes http:// ou https:// et les slashes à la fin
    formattedShop = formattedShop.replace(/^https?:\/\//, '').replace(/\/$/, '');
    
    // Ajouter .myshopify.com si nécessaire
    if (!formattedShop.includes('.myshopify.com')) {
      formattedShop = `${formattedShop}.myshopify.com`;
    }

    console.log('Tentative de connexion à la boutique:', formattedShop);
    
    // Récupérer le token du localStorage si non fourni
    if (!token) {
      token = localStorage.getItem('token');
      console.log('Token récupéré du localStorage:', token ? 'Présent' : 'Absent');
    } else {
      console.log('Token fourni en paramètre:', token ? 'Présent' : 'Absent');
    }
    
    if (!token) {
      console.warn('Aucun token trouvé pour l\'initialisation Shopify, génération d\'un nouveau token...');
      token = await user.getIdToken();
      console.log('Nouveau token généré, longueur:', token.length);
    }
    
    console.log('URL API pour l\'initialisation Shopify:', `${API_URL}/api/auth/init`);
    
    const response = await fetch(`${API_URL}/api/auth/init`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ 
        uid: user.uid,
        shopName: formattedShop 
      })
    });

    console.log('Status réponse init Shopify:', response.status);
    const responseText = await response.text();
    console.log('Réponse texte:', responseText);

    if (!response.ok) {
      let errorMessage;
      try {
        const errorData = JSON.parse(responseText);
        errorMessage = errorData.error;
      } catch (e) {
        errorMessage = responseText;
      }
      throw new Error(errorMessage || 'Erreur lors de la connexion Shopify');
    }

    const data = JSON.parse(responseText);
    console.log('URL de redirection Shopify:', data.url);
    return data;
  } catch (error) {
    console.error('Erreur d\'initialisation Shopify:', error);
    throw error;
  }
};

export const loginUser = async (email, password) => {
  try {
    console.log('Début de la connexion avec:', email);
    
    // Connexion à Firebase
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    console.log('Utilisateur connecté à Firebase:', user.uid);
    
    // Appeler notre API backend
    const url = `${API_URL}/api/auth/login`;
    console.log('Appel API login:', url);
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Origin': window.location.origin
      },
      credentials: 'include',
      body: JSON.stringify({ 
        email: user.email,
        uid: user.uid 
      })
    });

    console.log('Status réponse login:', response.status);
    const responseText = await response.text();
    console.log('Réponse texte:', responseText);

    if (!response.ok) {
      let errorMessage;
      try {
        const errorData = JSON.parse(responseText);
        errorMessage = errorData.error;
      } catch (e) {
        errorMessage = responseText;
      }
      throw new Error(errorMessage || 'Erreur lors de la connexion');
    }

    const data = JSON.parse(responseText);
    console.log('Données utilisateur du backend:', data);
    
    // Stocker le token dans localStorage pour les appels API ultérieurs
    if (data.token) {
      localStorage.setItem('token', data.token);
      console.log('Token stocké dans localStorage');
    } else {
      console.warn('Aucun token reçu du serveur');
    }
    
    return { ...user, ...data.user };
  } catch (error) {
    console.error('Erreur de connexion:', error);
    throw error;
  }
};

export const logoutUser = async () => {
  try {
    // Supprimer le token du localStorage
    localStorage.removeItem('token');
    console.log('Token supprimé du localStorage');
    
    await signOut(auth);
    console.log('Utilisateur déconnecté de Firebase');
  } catch (error) {
    console.error('Erreur de déconnexion:', error);
    throw error;
  }
};

export const getCurrentUser = async () => {
  return new Promise(async (resolve, reject) => {
    try {
      const unsubscribe = onAuthStateChanged(auth, 
        async (user) => {
          unsubscribe();
          
          if (user) {
            console.log('Utilisateur Firebase trouvé:', user.email);
            
            try {
              // Récupérer les données utilisateur de Firestore
              const userData = await getUserData(user.uid);
              console.log('Données utilisateur Firestore:', userData);
              
              if (userData) {
                resolve({ ...user, ...userData });
              } else {
                console.log('Aucune donnée utilisateur trouvée dans Firestore');
                resolve(user);
              }
            } catch (firestoreError) {
              console.error('Erreur lors de la récupération des données Firestore:', firestoreError);
              resolve(user);
            }
          } else {
            console.log('Aucun utilisateur connecté');
            resolve(null);
          }
        },
        (error) => {
          console.error('Erreur lors de la vérification de l\'état d\'authentification:', error);
          reject(error);
        }
      );
    } catch (error) {
      console.error('Erreur dans getCurrentUser:', error);
      reject(error);
    }
  });
};

export const getUserData = async (userId) => {
  try {
    const userDoc = await getDoc(doc(db, 'users', userId));
    if (userDoc.exists()) {
      return userDoc.data();
    }
    return null;
  } catch (error) {
    console.error('Erreur de récupération des données:', error);
    throw error;
  }
};

// Nouvelle fonction pour connecter une boutique Shopify à un compte existant
export const connectShopifyToExistingAccount = async (shopName) => {
  try {
    const auth = getAuth();
    const user = auth.currentUser;
    
    if (!user) {
      throw new Error('Vous devez être connecté pour ajouter une boutique Shopify');
    }
    
    console.log('Tentative de connexion de la boutique Shopify:', shopName);
    console.log('Utilisateur actuel:', user.uid);
    
    // Formater le nom de la boutique
    let formattedShopName = shopName;
    if (typeof shopName === 'object') {
      formattedShopName = shopName.domain || '';
    }
    
    // Supprimer les préfixes http:// ou https:// et les slashes à la fin
    formattedShopName = formattedShopName.replace(/^https?:\/\//, '').replace(/\/$/, '');
    
    // Ajouter .myshopify.com si nécessaire
    if (!formattedShopName.includes('.myshopify.com')) {
      formattedShopName = `${formattedShopName}.myshopify.com`;
    }
    
    // Vérifier si le token est disponible
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('Token d\'authentification non disponible');
    }
    
    // Mettre à jour les informations utilisateur dans Firestore
    const userData = {
      shopifyShop: formattedShopName,
      shopifyConnected: false,
      shopifyPendingConnection: true,
      updatedAt: new Date().toISOString()
    };
    
    // Mettre à jour le document utilisateur dans Firestore
    await setDoc(doc(db, 'users', user.uid), userData, { merge: true });
    console.log('✅ Informations Shopify ajoutées au compte utilisateur');
    
    // Initialiser la connexion Shopify
    const shopifyResponse = await initShopifyConnection(user, formattedShopName, token);
    return { shopifyUrl: shopifyResponse.url };
  } catch (error) {
    console.error('Erreur lors de la connexion de la boutique Shopify:', error);
    throw error;
  }
};
